<template>
    <div class="main main-padding new-data-details">
        <div class="top-area">
            <!--返回-->
            <div class="main-back">
                <div class="bank-back" v-on:click="gotoBack">
                    <img src="../../../../assets/images/back.png"/>
                    <p class="click-text">返回</p>
                </div>
            </div>
            <!--时间选择器-->
            <div class="time-select-picker">
                <div class="time-select">
                    <Row :gutter="10">
                        <date-select @updateDateTime="updateDateTime" ref="dateSelect"></date-select>
                    </Row>
                </div>
            </div>
        </div>
        <!--数据信息-->
        <card>
            <!--标题及搜索框-->
            <div class="details-card-header-area">
                <!--tab切换数据-->
                <div class="details-tab-data">
                    <span>大屏使用场景详情数据</span>
                </div>
                <!--搜索框-->
                <div class="input-data">
                    <Input
                        v-model="keyWord"
                        placeholder="支持教师名称关键字搜索"
                        icon="ios-search"
                        clearable
                        @on-enter="handleSearch"
                    >
                        <Button
                            slot="append"
                            icon="ios-search"
                            class="search-input-button"
                            @click="handleSearch"
                            type="primary"
                        ></Button>
                    </Input>
                </div>
            </div>
            <div>
                <!--教师使用大屏的场景详情-->
                <div class="table-wrapper-data">
                    <Table :columns="screenColumn" :data="teaUseScreenList"></Table>
                </div>
                <!--分页,大屏重复绑定情况下不显示-->
                <div class="laypage_main">
                    <Page
                        :total="total"
                        :current="page"
                        :page-size="limit"
                        @on-change="handleCurrentChange"
                        v-show="total && pageCount>1"
                        show-total
                    />
                </div>
            </div>
        </card>
    </div>
</template>

<script>
    import {getSchoolTeacherCountKey} from "../../../../service/api.js";
    import dateSelect from "../../../../components/dateSelect.vue";

    export default {
        name: "tea-user-screen-details",
        data () {
            return {
                schoolId: this.$route.query.schoolId,//学校Id
                schoolName: this.$route.query.schoolName,//学校名称
                routerName: this.$route.query.routerName,//路由名称
                initStartDate: this.$route.query.startDate,//开始时间
                initEndDate: this.$route.query.endDate,//结束时间
                codingKey: this.$route.query.codingKey,//场景编码
                startDate: this.$route.query.startDate,//开始时间
                endDate: this.$route.query.endDate,//结束时间
                keyWord: "",//关键字
                page: 1,//当前页
                limit: 10,//每页数据
                pageCount: 0,//页数
                total: 0,//数据总量
                screenColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        align: "center"
                    },
                    {
                        title: "教师姓名",
                        key: "name",
                        align: "center"
                    },
                    {
                        title: "使用次数",
                        key: "count",
                        align: "center"
                    },
                    {
                        title: "动态数据",
                        key: "dynamic_data",
                        align: "center"
                    }
                ],
            }
        },
        components: {
            dateSelect
        },
        methods: {
            /**
             * 返回上一页
             */
            gotoBack () {
                this.$router.push({
                    name: this.routerName,
                    query: {
                        startDate:this.initStartDate,
                        endDate:this.initEndDate,
                        schoolId:this.schoolId,
                        schoolName: this.schoolName
                    }
                })
            },
            /**
             * 更新时间
             */
            updateDateTime (startDate, endDate) {
                this.page = 1;
                this.startDate = startDate;
                this.endDate = endDate;
                this.getSchoolTeacherCountKey();
            },
            /**
             * 搜索关键字
             */
            handleSearch () {
                this.page=1;
                this.total = 0;
                this.getSchoolTeacherCountKey();
            },
            /**
             *分页
             */
            handleCurrentChange (val) {
                this.page = val;
                this.getSchoolTeacherCountKey();
            },
            /**
             *获取教师大屏使用场景详情
             */
            async getSchoolTeacherCountKey () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startTime: _this.startDate,
                    endTime: _this.endDate,
                    codingKey: _this.codingKey,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await getSchoolTeacherCountKey(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.teaUseScreenList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            }
        },
        mounted () {
            this.getSchoolTeacherCountKey();
            //记住页面选择的开始和结束时间
            this.$refs.dateSelect.setDate(this.initStartDate, this.initEndDate);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../style/home";
    @import "../../../../style/dataDetails";
</style>
<style lang="scss">
    .new-data-details {
        .ivu-input-group {
            width: 300px;
            float: right;
        }

        .ivu-card-body {
            padding: 16px;
        }

        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }
        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
        }
        .ivu-row {
            margin-top: 0 !important;
        }
        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }
        .ivu-table-overflowX {
            overflow-x: hidden;
        }
    }
</style>
